import axios from 'utils/axios';

export const getDoctorCerts = (doctorId: string) => {
  return axios.get(`/publicapi/v1/doctors/${doctorId}/certs`);
};
